var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45184 16.8948C10.3288 16.8949 12.1522 16.2686 13.633 15.1152L19.2197 20.7019C19.637 21.105 20.302 21.0934 20.7051 20.6761C21.0983 20.2689 21.0983 19.6235 20.7051 19.2165L15.1184 13.6298C17.9805 9.94559 17.314 4.6388 13.6298 1.77676C9.94554 -1.08529 4.6388 -0.418815 1.77676 3.26541C-1.08529 6.94963 -0.418815 12.2564 3.26541 15.1185C4.74865 16.2707 6.57362 16.8958 8.45184 16.8948ZM3.963 3.95977C6.44215 1.48058 10.4616 1.48054 12.9408 3.95968C15.42 6.43882 15.4201 10.4583 12.9409 12.9375C10.4618 15.4167 6.44228 15.4167 3.96309 12.9376L3.963 12.9375C1.48386 10.4764 1.46925 6.47159 3.93033 3.99244L3.963 3.95977Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.0dee083fa551c3aeb75444432c62ecec.svg";
export { ForwardRef as ReactComponent };